import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCancelSubscription } from '../../../domains/payments/ui/hooks/useCancelSubscription';
import type { RefundRequestReasonType } from './useBettieRefundRequest';

export const useSubscriptionCancel = () => {
  const navigate = useNavigate();
  const { subscriptionId } = useParams<{ subscriptionId: string }>();
  const { mutateAsync: cancelSubscription } = useCancelSubscription();

  const [selectedReasonType, setSelectedReasonType] = useState<RefundRequestReasonType>('pricey');
  const [cancelDetail, setCancelDetail] = useState('');

  const handleCancelSubscription = async () => {
    if (!subscriptionId) {
      return;
    }
    try {
      const body = {
        subscription: {
          cancel_type: selectedReasonType as 'pricey' | 'low_usage' | 'changed_my_mind' | 'others',
          cancel_detail: cancelDetail
        }
      };
      const response = await cancelSubscription({ subscriptionId, body });
      if (response?.subscriptionId) {
        navigate(`/subscription/${subscriptionId}/cancel-success?cancel_date=${response.canceledAt}`, {
          replace: true
        });
      } else {
        throw new Error('Failed to cancel subscription');
      }
    } catch (error) {
      console.error(error);
    }
  };
  return {
    handleCancelSubscription,
    selectedReasonType,
    setSelectedReasonType,
    cancelDetail,
    setCancelDetail
  };
};
